// extracted by mini-css-extract-plugin
export default {"input":"U1IWx3JeXHnfzbOXj4EOs"};